var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgType1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.4375 14.4116V2.44585C1.44327 2.01734 1.61604 1.608 1.91907 1.30497C2.2221 1.00194 2.63144 0.829146 3.05996 0.823372H12.4568C12.5194 0.821891 12.5816 0.833119 12.6397 0.856376C12.6978 0.879633 12.7505 0.914435 12.7948 0.958677C12.839 1.00292 12.8738 1.05568 12.897 1.11376C12.9203 1.17185 12.9315 1.23404 12.93 1.29659V15.6961",
    stroke: "#E9A5F3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 4.06738H9.68506",
    stroke: "#E9A5F3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.40234 10.625H12.7456",
    stroke: "#E9A5F3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.40234 13.127H12.7456",
    stroke: "#E9A5F3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.65625 15.6279H12.9996",
    stroke: "#E9A5F3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.65669 13.1263C2.50426 13.1426 2.35008 13.1269 2.20409 13.0801C2.0581 13.0334 1.92351 12.9566 1.80893 12.8547C1.69435 12.7529 1.60231 12.6282 1.53874 12.4887C1.47518 12.3492 1.44151 12.198 1.43984 12.0447V11.8419C1.42353 11.6894 1.43924 11.5353 1.48601 11.3893C1.53278 11.2433 1.60958 11.1087 1.71143 10.9941C1.81327 10.8795 1.93791 10.7875 2.07742 10.7239C2.21692 10.6604 2.36818 10.6267 2.52148 10.625H2.65669",
    stroke: "#E9A5F3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.65669 15.6283C2.50426 15.6446 2.35008 15.6289 2.20409 15.5821C2.0581 15.5353 1.92351 15.4585 1.80893 15.3567C1.69435 15.2548 1.60231 15.1302 1.53874 14.9907C1.47518 14.8512 1.44151 14.6999 1.43984 14.5466V14.3438C1.42353 14.1914 1.43924 14.0372 1.48601 13.8912C1.53278 13.7452 1.60958 13.6106 1.71143 13.4961C1.81327 13.3815 1.93791 13.2895 2.07742 13.2259C2.21692 13.1623 2.36818 13.1286 2.52148 13.127H2.65669",
    stroke: "#E9A5F3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgType1);
export default __webpack_public_path__ + "static/media/type1.578953553192203a62b292d3c9ff5842.svg";
export { ForwardRef as ReactComponent };